import React from "react";
import styled from "styled-components";
import {contentMaxWidth} from "src/themes/utils/media";
import Header from "src/core/common/components/collections/menu/simple";
import CategoryBar from "@menu/components/CategoryBar";
import DeliveryBanner from "src/core/deliveries/components/DeliveryBanner";
import AnnouncementMessage from "@menu/components/AnnouncementMessage";
import useFeatureToggles from "src/core/common/hooks/useFeatureToggles";
import dynamic from "next/dynamic";
import {logModuleLoadError} from "src/core/common/utils";
import useBasePage from "src/core/common/hooks/useBasePage";

export default function BaseThemeBasePage({children, ...props}) {
  const {showAnnouncementMessage} = useBasePage();
  const toggles = useFeatureToggles();
  return (
    <>
      <Header />
      {!toggles.kioskMode() && <DeliveryBanner />}
      {showAnnouncementMessage && <AnnouncementMessage />}
      <CategoryBar />
      <Content>{children}</Content>
      <ProductDetailModal {...props} />
    </>
  );
}

const ProductDetailModal = dynamic(
  () =>
    import("src/core/pages/ProductDetail").catch(
      logModuleLoadError("ProductDetail", {critical: true})
    ),
  {
    ssr: true,
  }
);

const Content = styled.div`
  margin: 0 auto;
  max-width: ${contentMaxWidth};
`;
